export default "__VITE_ASSET__8spmP5v___"